module.exports = __webpack_public_path__ + "static/media/banner_bg.0350ac07.png";